import { SHTableRow, SHTableRowProps } from "@components/design-systems";
import { useTheme } from "@mui/material";

export const FeePortfolioDetailsTableRow = (props: SHTableRowProps) => {
  const { palette } = useTheme();

  return (
    <SHTableRow
      {...props}
      sx={{
        borderBottomWidth: 1,
        backgroundColor: `${palette.common.white} !important`,
        ...props.sx,
      }}
    />
  );
};
